import { useRef } from "react";
import { useGsapNotFoundHeadline, useGsapNotFoundImg } from "../Hooks/gsap";

const NotFound = () => {
  const leftHeadlineRef = useRef(null);
  const rightHeadlineRef = useRef(null);
  const leftImgRef = useRef(null);
  const rightImgRef = useRef(null);

  useGsapNotFoundHeadline(leftHeadlineRef);
  useGsapNotFoundHeadline(rightHeadlineRef, "100vw");
  useGsapNotFoundImg(leftImgRef);
  useGsapNotFoundImg(rightImgRef);

  return (
    <div className="not-found wrapper">
      <div className="headline-1 " ref={leftHeadlineRef}>
        Sorry, we couldn't
      </div>
      <div className="img-1" ref={rightImgRef}>
        <img
          src={`/images/notfound/photo1.jpg`}
          alt="okatt"
        />
      </div>
      <div className="img-2" ref={leftImgRef}>
        <img
          src={`/images/notfound/photo2.jpg`}
          alt="okayyy"
        />
      </div>
      <div className="headline-2" ref={rightHeadlineRef}>
        Find that page
      </div>
    </div>
  );
};

export default NotFound;
